module.exports = __webpack_public_path__ + "static/swap-kmd-tkl-42aa301e71f134cd28f49d11c78d9666.svg";